import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Datepicker } from '@wmgtech/legato'
import { DateRangePickerCustomProps } from './DateRangePicker.props'

import styles from './DateRangePicker.module.scss'

export const WeekPicker: FC<DateRangePickerCustomProps> = ({
  startDate,
  value,
  onChange,
  isSelected
}) => (
  <Datepicker
    className={cn('items-list__item', styles.inputButton, {
      'items-list__item--checked': isSelected
    })}
    onChange={onChange}
    placeholder="Select week"
    value={value}
    selected={startDate}
    size="md"
    showWeekNumbers
    showWeekPicker
    calendarContainer={({ className, children }: any) =>
      <div className={cn(className, styles.week)}>{children}</div>
    }
  />
)
